<app-header></app-header>
<div class="main-container d-flex">
  <app-sidebar></app-sidebar>
  <div class="container-fluid h-100p overflow-y-scroll image-search-main px-2 px-sm-3 px-lg-4">
    <app-face-search-tabs
      activeTab="video-scanner"
      [showBack]="showBack"
      (back)="onBack()">
      <div class="credits-display">
        <div class="credits-inline">
          <span class="credits-inline-label">Remaining:</span>
          <span class="credits-inline-value"><i class="fas fa-spinner fa-spin" *ngIf="creditsLoading" aria-hidden="true"></i><ng-container *ngIf="!creditsLoading">{{ availableCredits | creditsLabel }}</ng-container></span>
        </div>
        <button class="buy-credits-btn" (click)="onBuyCreditsButtonClick()">
          <i class="fas fa-coins credits-icon"></i>
          Buy Credits
        </button>
      </div>
    </app-face-search-tabs>

    <div class="search-card-container" *ngIf="isServiceDisabled">
      <div class="service-disabled-warning">
        <div class="warning-icon">
          <i class="fas fa-exclamation-triangle"></i>
        </div>
        <h2 class="warning-title">Search temporarily unavailable</h2>
        <p class="warning-message">
          We're experiencing a temporary service issue. You can still access and export your previous search history below.
        </p>
      </div>
    </div>

    <router-outlet *ngIf="!isServiceDisabled"></router-outlet>
  </div>
</div>
